import { render, staticRenderFns } from "./CollapseToggler.vue?vue&type=template&id=6c3324aa&"
import script from "./CollapseToggler.vue?vue&type=script&lang=js&"
export * from "./CollapseToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports